import { reduxForm } from 'redux-form';
import Component from './FormSettingManualTransaction';
import { validate, initialValues } from './schema';

const FormSettingManualTransaction = reduxForm({
  form: 'formSettingManualTransaction',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FormSettingManualTransaction;
